// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const OperatorsApi = ApiFactory.get('operators');

const fetch = async ({ commit }, id) => {
  const { data } = await OperatorsApi.get(id);
  commit("SET_NAME", data.name);
  const image = process.env.VUE_APP_IMAGE_DOMAIN + data.logo.split('.com')[1];
  commit("SET_LOGO", image);

  commit("SET_ID", data.id);
  return data.id;
};

export default {
  fetch
};
